<template>
  <div class="GlobalFormDemo">
    <GlobalForm
      :init-data="initData"
      :form-rules="formRules"
      :form-item-list="formItemList"
      :needBtnLoading="true"
      :inline="true"
      round
      @handleConfirm="handleConfirm"
      confirmBtnName="查询"
      :labelWidth=80
    >
      <div style="position: relative;text-align: right" slot="AddSlot">
        <span class="tip_num" v-if="number.notApproved">{{number.notApproved}}</span>
        <el-button size="small" type="primary" @click="check">查看合作申请</el-button>
      </div>
    </GlobalForm>
    <DialogTbale
      @onClose="merchantClose"
      :loading="merchantLoading"
      :show="merchantVisible"
      title="查看合作申请"
      :columns="merchantColumns"
      :data="dialogList"
      :currentPage="merchantParams.pageNum"
      :total="merchantParams.total"
      :pageSize="10"
      :width="1100"
      maxHeight= 500
      @handleCurrentChange="getMerchantList"
    >
    <div class="button_top">
      <div class="radiobtn">
        <div class="faultBtn">
            <div :class="this.clickShow=== '00'? 'active' : 'none'" @click="btnClick('00')">
              待审核({{number.notApproved}})
            </div>
            <div :class="this.clickShow=== '01'? 'active' : 'none'" @click="btnClick('01')">
              已通过({{number.approved}})
            </div>
            <div :class="this.clickShow=== '02'? 'active' : 'none'" @click="btnClick('02')">
              已拒绝({{number.rejected}})
            </div>
        </div>
      </div>
    </div>
      <el-table-column label="省市区" slot="operationAddress" align="center">
        <template slot-scope="{ row }">
          <span>{{row.province}}{{row.city}}{{row.region}}</span>
        </template>
      </el-table-column>
      <el-table-column label="商家地址" slot="operationAddress" align="center">
        <template slot-scope="{ row }">
          <el-tooltip :content="row.merchantAddress" placement="top">
            <p style="display: -webkit-box;-webkit-box-orient: vertical;-webkit-line-clamp: 3;overflow: hidden;">{{row.merchantAddress}}</p>
          </el-tooltip>
        </template>
      </el-table-column>
      <el-table-column :label="clickShow=='00'?'申请合作时间':clickShow=='01'?'达成合作时间':'拒绝合作时间'" slot="operation" align="center">
        <template slot-scope="{ row }">
          <span>{{row.applyTime}}</span>
        </template>
      </el-table-column>
      <el-table-column label="营业执照" slot="operation" align="center">
        <template slot-scope="{ row }">
          <img style="width:56px" :src="row.businessLicense" alt="" @click="seeImg(row)">
        </template>
      </el-table-column>
      <el-table-column label="操作" slot="operation" align="center" v-if="clickShow!='01'">
        <template slot-scope="{ row }">
          <el-button
            size="mini"
            type="primary"
            round
            @click="handleBtn(row)"
          >{{clickShow=='00'?'撤销审核':'重新审核'}}
          </el-button>
        </template>
      </el-table-column>
    </DialogTbale>
    <GlobalDialog
      :title="dialogTitle"
      :show="dialogVisible"
      :width="400"
      @resetPopupData="resetPopupData"
      @submitPopupData="submitPopupData"
      @onClose="onClose"
      >
      <div style="font-size:16px;color:#666666;">确认要执行该操作吗？</div>
    </GlobalDialog>
    <el-image-viewer
      style="z-index:2050"
      v-if="showViewer"
      :on-close="() => {showViewer = false}"
      :url-list="imgList"
    />
  </div>
</template>

<script>
import {formValidateMobile} from '@/utils/form-validate'
import _api from "@/utils/request";
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
export default {
  name: 'Form',
  components: { ElImageViewer },
  data() {
    return {
      merchantName :"",
      startTime:"",
      endTime:"",
      contactPhone:"",
      initData: null,
      merchantLoading: false,
      merchantVisible: false,
      dialogList: [],
      clickShow: '00',
      imgList: [],
      showViewer: false,
      dialogTitle: "",
      dialogVisible: false,
      merchantCompanyId: '',
      formItemList: [
        {
          key: 'staffName',
          type: 'input',
          labelName: '商家名称',
          placeholder: '请输入商家名称'
        },
        {
          key: 'mobile',
          isNumber: true,
          type: 'input',
          labelName: '联系电话',
          placeholder: '请输入联系电话'
        },
        {
          key: 'entryTime',
          type: 'daterange',
          labelName: '合作时间',
          placeholder: '请选择合作时间',
          valueFormat:"timestamp"
        }
        // {slot:'AddSlot'}
      ],
      merchantColumns: [
          { label: "回收商家名称", prop: "merchantName" },
          { label: "联系人", prop: "contact" },
          { label: "联系电话", prop: "contactPhone" },
          { slotName: "operationAddress" },
          // { label: '申请合作时间', prop: 'applyTime'},
          // { slotName: "applyTime" },
          { slotName: "operation" }
      ],
      merchantParams: {
        pageNum: 1,
        pageSize: 10
      },
      number:{},
      formRules: {
        mobile: [{
          validator: formValidateMobile,
          trigger: 'blur'
        }]
      },
    }
  },
  // created(){
  //   this.handleConfirm()
  // },
  watch: {
    clickShow(newVal){
      this.getMerchantList()
    }
  },
  methods: {
    handleConfirm(data,cd) {
      if(data){
        if(data.entryTime===null){
        this.startTime="",
        this.endTime="",
        this.merchantName=data.staffName
        this.contactPhone=data.mobile
        }else{
          this.contactPhone=data.mobile
          this.merchantName=data.staffName,
          this.startTime=data.entryTime[0],
          this.endTime=data.entryTime[1]
        }
      }else{
        this.merchantName = ""
        this.startTime =""
        this.endTime =""
        this.contactPhone =""
      }
      const SeachParams = {
        merchantName:this.merchantName,
        contactPhone: this.contactPhone,
        startTime: this.startTime,
        endTime:this.endTime,
        pageNum: 1,
        pageSize: 10,
        disuseLoding: () => {
          if (typeof cd === 'function') {
            cd()
          }
        }
      }
      this.$store.commit('tagsView/SEACH_PARAMS',SeachParams)
    },
    // 获取合作回收商家
    getMerchantList(val){
      if (val) {
        this.merchantParams.pageNum = val;
      } else {
        this.merchantParams.pageNum = 1;
      }
      const params = {
        applyStatus: this.clickShow,
        pageNum: this.merchantParams.pageNum,
        pageSize: this.merchantParams.pageSize
      }
      this.merchantLoading = true
      _api.queryUnionList(params).then(res =>{
        if(res.code===1){
          this.number = {
            notApproved:res.data.notApproved,
            approved:res.data.approved,
            rejected:res.data.rejected,
          }
          this.dialogList = res.data.page.records
          this.merchantParams.total = res.data.page.total
          this.merchantParams.pageNum = res.data.page.current
          this.merchantLoading = false
          
        }
        this.merchantLoading = false
      })
    },
    btnClick(type){
      this.clickShow = type
    },
    //查看回收商家弹窗关闭
    merchantClose(){
      this.merchantVisible = false
    },
    // 显示弹窗
    check(){
      this.getMerchantList()
      this.merchantVisible = true
    },
    // 查看营业执照
    seeImg(val){
      console.log(val);
      this.imgList = []
      this.showViewer = true
      this.imgList.push(val.businessLicense);
    },
    // 撤销审核/重新审核
    handleBtn(row){
      this.dialogVisible = true
      this.merchantCompanyId = row.merchantCompanyId
      if(this.clickShow == '00'){
        this.dialogTitle = '撤销审核'

      }else{
        this.dialogTitle = '重新审核'
        this.dialogVisible = true

      }
    },
    //启用弹窗取消
    resetPopupData() {
      this.dialogVisible = false;
    },
    onClose() {
      this.dialogVisible = false;
    },
    submitPopupData() {
      let type = this.clickShow == '00'?'03':'05'
      _api.listOper({merchantCompanyId:this.merchantCompanyId,type}).then(res => {
        if(res.code===1){
          this.$message.success(res.msg)
          this.getMerchantList()
        }
      })
      this.dialogVisible = false;
    }
  }
}
</script>

<style scoped lang="scss" ref="stylesheet/scss">
.GlobalFormDemo{
  /deep/ .el-form--inline .el-form-item{
    margin-right: 30px!important;
  }
  .button_top{
    margin-bottom: 20px;;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .faultBtn{
    width: 280px;
    height: 34px;
    background: #F9FBFD;
    border: 1px solid #C1D1FF;
    box-shadow: 0px 4px 8px 0px rgba(196, 197, 198, 0.2);
    border-radius: 21px;
    display: flex;
    cursor: pointer;
    .active{
      text-align: center;
      color: white;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      background: #0981FF;
      border-radius: 20px;
    }
    .none{
      text-align: center;
      color: #333;
      width: 50%;
      height: 14px;
      font-size: 14px;
      font-family: FZLanTingHei-M-GBK;
      font-weight: 400;
      line-height: 32px;
      height: 32px;
      border-radius: 20px;
    }
  }
  .tip_num{
    position: absolute;
    top: -8px;
    left: -13px;
    width: 26px;
    height: 26px;
    border-radius: 50%;
    background-color: #ff0000;
    line-height: 25px;
    text-align: center;
    color: #fff;
    border: 1px solid #fff;
    box-shadow: 0 0 5px rgba(255, 0, 0,0.5);
  }
}
</style>
